import React from "react";
import './styles.css';

export const LoadingButton = () => {
  return (
    <button className="loading-button">CARREGAR MAIS</button>
  )
}